import { isNumber } from "./is-number";
import { isString } from "./is-string";

export const NOT_NUMBER_REGEX = /[^0-9.]/g;

// keep number and dot only
export const getAsNumber = (v: unknown, asInteger = false) => {
  if (isNumber(v)) return asInteger ? Math.floor(v) : v;

  if (isString(v)) {
    const cleanedValue = v.replace(NOT_NUMBER_REGEX, "");

    if (!cleanedValue) return null;

    const numericValue = +cleanedValue;
    return asInteger ? Math.floor(numericValue) : numericValue;
  }

  return null;
};
